export const MIN_USERNAME_LENGTH = 3;
export const MIN_AGE = 18;

// in MB
export const MAX_FILE_SIZE = {
  CONTACT_US: 10, // 10 MB
  CREATOR_REGISTRATION: 10, // 10 MB
};

// Profile tags validation constants
export const PROFILE_TAGS = {
  MIN_TAGS: 1,
  MAX_TAGS: 5,
};

export const USER_TAG = {
  DEFAULT_AVATAR: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg",
  SEARCH_DEBOUNCE_MS: 300,
  MIN_SEARCH_LENGTH: 2,
};

export const UPLOAD_CONTENT = {
  MAX_FILES: 20,
  MAX_SIZE_MB: 3 * 1024, // 3GB in MB
  INITIAL_VISIBLE_COUNT: 3,
  LOAD_MORE_INCREMENT: 3,
};